import * as R from "ramda";
import React from "react";
import FlexView from "react-flexview";
import { connect } from "react-redux";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import * as ErrorAction from "../../../../../Redux/ErrorRedux";
import Api from "../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../Services/Utils";
import SimpleCheckBox from "../../../../../modules/SimpleCheckBox";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import Container from "../../../../../modules/commons/Container";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import { HttpStatus } from "../../../../common/Constants";
import { mapToObjectDDL } from "../../../../common/mapper";
import LaporanYTD from "./laporanYTD/laporanYTD";
import LaporanPendapatan from "./laporanPendapatan/laporanPendapatan";
import LaporanPartYTD from "./laporanPartYTD/laporanPartYTD";
import LaporanSalesAbilityYTD from "./laporanSalesAbilityYTD/laporanSalesAbilityYTD";
import LaporanPenjualanByPromo from "./laporanPenjualanByPromo/laporanPenjualanByPromo";
import LaporanPenjualanByPaket from "./laporanPenjualanByPaket/laporanPenjualanByPaket";
import LaporanStatistikBooking from "./laporanStatistikBooking/laporanStatistikBooking";
import LaporanFjbByTypeYTD from "./laporanFjbByTypeYTD/laporanFjbByTypeYTD";

class DashboardLaporanTambahan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      isAllSelected: true,
      isSpecificSelected: false,
      dataCabang: [],
      kodeCabang: [],
      search: {},
    };
  }

  componentDidMount = async () => {
    await this.fetchDataCabang();
  };

  componentDidUpdate(prevProps, prevState, snapshot) {}

  handleChangeDoSearch = (value) => {};

  fetchDataCabang = async () => {
    this.handleTriggerLoading();
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
      setError: this.props.setError,
      menuName:
        "Dashboard Level Kepala Cabang Keatas - Laporan Harian By Cabang",
      args: null,
    });

    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      let filteredData = res.data.data.filter((item) =>
        this.props.menuAccess
          .map((data) => data.idRefObj)
          .includes(item.kodeCabang),
      );

      if (filteredData.length !== 0) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataCabang: filteredData,
        }));
      }
    }
    this.handleTriggerLoading();
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  handleSelectCabang = (e, type) => {
    const isChecked = e.target.checked;

    if (type === "ALL") {
      this.setState((prevValue) => ({
        ...prevValue,
        isAllSelected: isChecked,
        isSpecificSelected: false,
        kodeCabang: [],
      }));
    }

    if (type === "SPECIFIC") {
      this.setState((prevValue) => ({
        ...prevValue,
        isSpecificSelected: isChecked,
        isAllSelected: false,
        kodeCabang: [],
      }));
    }
  };

  handleSearch = () => {
    const { dataCabang, kodeCabang, isAllSelected, isSpecificSelected } =
      this.state;

    const kodeCabangList = isAllSelected
      ? dataCabang.map((item) => item.kodeCabang)
      : isSpecificSelected && kodeCabang?.length
        ? kodeCabang.map((item) => item.value)
        : [];

    this.setState((prev) => ({
      ...prev,
      search: kodeCabangList,
    }));
  };

  handleChangeCabang = (value) => {
    this.setState((prevValue) => ({ ...prevValue, kodeCabang: value }));
  };

  render() {
    const { search } = this.state;
    return (
      <React.Fragment>
        <Container>
          <FlexView style={{ gap: "20px", alignItems: "center" }}>
            <SimpleCheckBox
              id="reportAllCabang"
              key="reportAllCabang"
              name="reportAllCabang"
              label="ALL CABANG"
              checked={this.state.isAllSelected}
              onChange={(e) => this.handleSelectCabang(e, "ALL")}
            />
            <SimpleCheckBox
              id="reportSpecificCabang"
              key="reportSpecificCabang"
              name="reportSpecificCabang"
              label="SPESIFIK CABANG"
              checked={this.state.isSpecificSelected}
              onChange={(e) => this.handleSelectCabang(e, "SPECIFIC")}
            />
            <SimpleDDL
              id="select_options_kode_cabang"
              box="multiselect"
              name="kodeCabang"
              containerclassname="width width-500px margin-top-15px"
              placeholder="Nama Cabang"
              readOnly={!this.state.isSpecificSelected}
              options={this.state.dataCabang.map((item) =>
                mapToObjectDDL(item.namaDealer, item.kodeCabang),
              )}
              value={this.state.kodeCabang}
              onChange={(value) => this.handleChangeCabang(value)}
            />
            <SimpleButton
              onClick={this.handleSearch}
            >
              Cari
            </SimpleButton>
          </FlexView>
          <Tabs>
            <TabList>
              <Tab>Laporan Job Year To Date</Tab>
              <Tab>Laporan Pendapatan Job/Jasa Harian</Tab>
              <Tab>Laporan Parts In - Out Year To Date</Tab>
              <Tab>Laporan Sales Ability Year To Date</Tab>
              <Tab>Laporan FJB By type Year To Date</Tab>
              <Tab>Laporan Statistik Booking</Tab>
              <Tab>Laporan Penjualan By Paket</Tab>
              <Tab>Laporan Penjualan By Promo</Tab>
            </TabList>
            <TabPanel>
              <LaporanYTD
                {...this.props}
                search={search}
                onTriggerLoading={this.handleTriggerLoading}
              />
            </TabPanel>
            <TabPanel>
              <LaporanPendapatan
                {...this.props}
                search={search}
                onTriggerLoading={this.handleTriggerLoading}
              />
            </TabPanel>
            <TabPanel>
              <LaporanPartYTD
                {...this.props}
                search={search}
                onTriggerLoading={this.handleTriggerLoading}
              />
            </TabPanel>
            <TabPanel>
              <LaporanSalesAbilityYTD
                {...this.props}
                search={search}
                onTriggerLoading={this.handleTriggerLoading}
              />
            </TabPanel>
            <TabPanel>
              <LaporanFjbByTypeYTD
                {...this.props}
                search={search}
                onTriggerLoading={this.handleTriggerLoading}
              />
            </TabPanel>
            <TabPanel>
              <LaporanStatistikBooking
                {...this.props}
                search={search}
                onTriggerLoading={this.handleTriggerLoading}
              />
            </TabPanel>
            <TabPanel>
              <LaporanPenjualanByPaket
                {...this.props}
                search={search}
                onTriggerLoading={this.handleTriggerLoading}
              />
            </TabPanel>
            <TabPanel>
              <LaporanPenjualanByPromo
                {...this.props}
                search={search}
                onTriggerLoading={this.handleTriggerLoading}
              />
            </TabPanel>
          </Tabs>
        </Container>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(null, mapDispatchToProps)(DashboardLaporanTambahan);
